import * as Sentry from '@sentry/react';
import { isTransientFetchError } from '@/services/network';

type ErrorContext = Record<string, string | number | boolean | null | undefined>;

export const reportError = (
  message: string,
  error: unknown,
  context?: ErrorContext
) => {
  console.error(message, error);

  const normalizedError =
    error instanceof Error
      ? error
      : new Error(typeof error === 'string' ? error : message);

  if (isTransientFetchError(normalizedError)) {
    console.warn(message, normalizedError);
    return;
  }

  Sentry.captureException(normalizedError, {
    tags: {
      handled: 'true',
    },
    extra: {
      reportMessage: message,
      originalError: error instanceof Error ? undefined : String(error),
      ...context,
    },
  });
};
